import { render, staticRenderFns } from "./Ka_main.vue?vue&type=template&id=975a7626&scoped=true&"
import script from "./Ka_main.vue?vue&type=script&lang=js&"
export * from "./Ka_main.vue?vue&type=script&lang=js&"
import style0 from "./Ka_main.vue?vue&type=style&index=0&id=975a7626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975a7626",
  null
  
)

/* custom blocks */
import block0 from "./Ka_main.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCol,VContainer,VForm,VProgressLinear,VRow})
